import React from 'react';
import { Check, CheckCheck } from 'lucide-react';

const Message = ({ message, isSender }) => {
  // Render message status icon based on status
  const renderMessageStatus = (status) => {
    switch (status) {
      case 'READ':
        return <CheckCheck size={14} className="text-blue-500" />;
      case 'DELIVERED':
        return <CheckCheck size={14} className="text-gray-500" />;
      default:
        return <Check size={14} className="text-gray-300" />;
    }
  };

  const utcTimestamp = message.timestamp + 'Z';

  const formattedTime = new Date(utcTimestamp).toLocaleString('en-US', {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return (
    <div
      className={`p-2 rounded max-w-[80%] ${
        isSender ? 'bg-blue-100 self-end ml-auto' : 'bg-gray-100'
      }`}
    >
      <div>{message.content}</div>
      <div className="text-[10px] text-gray-400 text-right flex justify-end items-center">
        <span className="mr-1">{formattedTime}</span>
        {isSender && <span>{renderMessageStatus(message.status)}</span>}
      </div>
    </div>
  );
};

export default Message;
